import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { ConflictoAgenda } from "../../../utils/Disponibilidad";

// Pregunta si se guarda igualmente una cita o una clase con el profesional no disponible o la sala ocupada.
interface ConflictoDialogProps {
  conflicto: ConflictoAgenda | null;
  onConfirmar: () => void;
  onCancelar: () => void;
}

const ConflictoDialog = ({ conflicto, onConfirmar, onCancelar }: ConflictoDialogProps) => (
  <Dialog open={conflicto !== null} maxWidth="lg" onClose={onCancelar}>
    <DialogTitle>{conflicto?.titulo}</DialogTitle>
    <DialogContent>
      <DialogContentText>{conflicto?.mensaje}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onConfirmar} color="primary">SI</Button>
      <Button onClick={onCancelar} color="primary" autoFocus>NO</Button>
    </DialogActions>
  </Dialog>
);

export default ConflictoDialog;
